// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4yZV2l38x{overflow:hidden}._6ygrKzUix{overflow:auto;max-height:calc(100vh - 85px - 120px)}._1r3zXlNyx ._6ygrKzUix{max-height:calc(100vh - 85px - 80px - 120px)}._7qPFIzOTx ._6ygrKzUix{height:calc(100vh - 85px - 120px)}._7qPFIzOTx._1r3zXlNyx ._6ygrKzUix{height:calc(100vh - 85px - 80px - 120px)}\n", ""]);
// Exports
exports.locals = {
	"topBarHeight": "85px",
	"bottomBarHeight": "80px",
	"scrollable-dialog": "_4yZV2l38x",
	"scrollableDialog": "_4yZV2l38x",
	"scroll-container": "_6ygrKzUix",
	"scrollContainer": "_6ygrKzUix",
	"with-bottom-bar": "_1r3zXlNyx",
	"withBottomBar": "_1r3zXlNyx",
	"full-height": "_7qPFIzOTx",
	"fullHeight": "_7qPFIzOTx"
};
module.exports = exports;
